export const device = {
	isiOS: () => !!/os.*like mac os/.exec(navigator.userAgent.toLowerCase()),
};
